












































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Row from '@/components/atoms/Grid/Row.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import {
  EConnectTransactionStatus,
  FormManuallyReward,
  TransactionTableListAdmin
} from '@/models/transaction';
import eventBus from '@/utils/eventBus';
import DateFilter from '@/components/molecules/DateFilter/DateFilter.vue';
import dayjs from 'dayjs';
import { IPeriod } from '@/models/period';
import DatePicker from '@/components/DatePicker/DatePicker.vue';
import isMobile from '@/utils/mobile-check';
import DateUtils from '@/utils/DateUtils';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

interface IBusiness {
  id: string;
  label?: string;
  name: string;
  city: string;
  state: string;
}

interface ICustomer {
  id: string;
  mail: string;
  name: string;
  lastname: string;
  label?: string;
}

@Component({
  components: {
    ContentContainer,
    Row,
    SelectorAndList,
    TextInput,
    FilledButton,
    CustomSelect,
    TextField,
    DatePicker
  }
})
export default class ManuallyReward extends Vue {
  period: IPeriod = this.initialPeriod;

  @Prop({ required: false }) data!: TransactionTableListAdmin;
  @Prop({ default: '' }) dateStart?: string;
  @Prop({ default: false }) readonly hasError?: boolean;

  adminService = new AdminService();
  businesses = [] as any;
  customers = [] as any;
  amountValue: string = '';

  businessesOptions: IBusiness[] = [];
  customersOptions: ICustomer[] = [];
  eventsTypeAvailable: any = [];
  dataForm: FormManuallyReward = this.newDataForm();
  isLoading: boolean = false;
  placeholderValue: string = '';

  get isMobileDevice() {
    return isMobile();
  }

  created() {
    this.initSelectEventTypesAvailable();
    this.dataForm = this.newDataForm();
    this._setBusinessDefault();
    this._setCustomerDefault();
  }

  onPeriodInput(newPeriod: IPeriod) {
    this.period = newPeriod;
  }

  get initialPeriod() {
    return {
      end: dayjs()
        .utc()
        .toISOString(),
      start: dayjs()
        .utc()
        .add(-7, 'days')
        .toISOString(),
      shortcut: ''
    };
  }

  async searchBusinesses(search: string) {
    try {
      const {
        data: { items }
      } = await this.adminService.searchBusinesses(search, true);

      this.businessesOptions = items.map(business => {
        return {
          label: `${business.name} (${getBusinessLocationInfo(business)})`,
          ...business
        };
      });
    } catch (e) {
      this.businessesOptions = [];
    }
  }

  async searchCustomers(search: string) {
    try {
      const {
        data: { items }
      } = await this.adminService.searchCustomers(search);

      this.customersOptions = items.map(({ customer }) => {
        return {
          label: `${customer.mail} (${customer.name} ${customer.lastname}) `,
          ...customer
        };
      });
    } catch (e) {
      this.customersOptions = [];
    }
  }

  sendManuallyReward() {
    try {
      if (!this.validateFields()) {
        return;
      }

      this.isLoading = true;
      this.sendEventConfirmation();

      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$notification(treatError(e));
    }
  }

  private _setBusinessDefault() {
    this.businesses = this.data
      ? [{ label: this.data.businessName, id: this.data.rawData.businessId }]
      : [];
  }

  private _setCustomerDefault() {
    this.customers = this.data
      ? [{ label: this.data.customerName, id: this.data.rawData.customer.mail }]
      : [];
  }
  newDataForm(): FormManuallyReward {
    this.amountValue = this.data ? this.data.amount.replace('$', '') : '0';

    const rawData = this.data ? this.data.rawData : null;
    return {
      businessId: rawData ? rawData.businessId : '',
      emailCustomer: rawData ? rawData.customer.mail : '',
      amount: parseFloat(this.amountValue),
      transactionDate: this.placeholderValue
    };
  }

  setAmount(value: string) {
    this.dataForm.amount = parseFloat(value);
  }

  validateFields() {
    const hasBusiness = !!this.dataForm.businessId;
    const hasCustomerEmail = !!this.dataForm.emailCustomer;
    const hasDate = !!this.placeholderValue;

    const fieldsValidate = hasBusiness && hasCustomerEmail && hasDate;

    if (!fieldsValidate) {
      this.$notification('Please, fill in all fields!! ', 'error');
    }

    return fieldsValidate;
  }

  private _getOptionsEventType(): CustomSelectOption[] {
    if (!this.data) {
      return [new CustomSelectOption('transaction.clearing', `Clear`, true)];
    }

    const opt = [];

    if (this.data.status === EConnectTransactionStatus.AUTHORIZED) {
      opt.push(new CustomSelectOption('transaction.clearing', `Clear`));
    }

    if (this.data.status === EConnectTransactionStatus.CLEARED) {
      opt.push(new CustomSelectOption('transaction.refund', `Refund`));
    }

    return opt;
  }
  initSelectEventTypesAvailable() {
    const options = this._getOptionsEventType();

    const actionGroup = new CustomSelectGroup(options);

    this.eventsTypeAvailable = new CustomSelectModel(
      [actionGroup],
      `Event Type`,
      false,
      true,
      false,
      true
    );
  }

  sendEventConfirmation() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'sendEventConfirmationModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          dataForm: this.dataForm
        },
        title: `Are you sure?`,
        subtitle: `This will create a transaction.`,
        onConfirm: async () => {
          const { status } = await this.adminService.sendManuallyReward(
            this.dataForm
          );

          if (status === 201) {
            this.$notification(
              'Event created with success. Please wait for the webhook be processed... '
            );

            this.closeModal();
            this.$emit('webhookCreated', true);
          }
          eventBus.$emit('closeModal');
        }
      }
    );
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: false,
      component: 'manuallyReward'
    });
  }

  handleChangeDate(date: string) {
    this.placeholderValue = DateUtils.formattedDate({
      date,
      applyTimezone: true
    });

    this.dataForm.transactionDate = date;
  }
}
